module.exports = "<div class=\"cat__footer\">\n  <a href=\"javascript: void(0);\" class=\"cat__core__scroll-top\"\n    onclick=\"$('body, html').animate({'scrollTop': 0}, 500);\"><i class=\"icmn-arrow-up\"></i></a>\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main